import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0Zm11.746 21.877v-4.53a8.624 8.624 0 0 1-2.78-.986 8.59 8.59 0 0 1-2.502-2.156 3.573 3.573 0 0 1-.768-2.074l-.025-.576-.024-.577h-4.529v17.8a3.914 3.914 0 0 1-3.902 4.15 3.913 3.913 0 0 1-3.907-3.908 3.913 3.913 0 0 1 5.218-3.683v-4.466a8.206 8.206 0 0 0-1.31-.104c-4.55 0-8.252 3.704-8.252 8.253 0 4.55 3.701 8.252 8.252 8.252 4.55 0 8.252-3.703 8.252-8.252 0-.186-.007-.371-.019-.553l.019.029v-9.16a11.919 11.919 0 0 0 6.277 2.54Z",
      fill: "#fff"
    }, null, -1)
  ]))]))
}
export default { render: render }